import { Dialog } from '@material-ui/core';
import * as lib from '~/dependencies';
import { colors, fonts, paddings } from '~/layout';

export const DialogComponent = lib.styled(Dialog)`
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;
    background-color: ${colors.white02};

    .trash-icon {
      background-color: ${colors.white};
      padding: ${paddings.default}px;
      margin-bottom: 20px;
      width: 40px;
      height: 40px;
      align-items: center;
      justify-content: center;
      display: flex;
      border-radius: 50%;
    }

    span {
      font-size: 16px;
      color: ${colors.black};
    }
  }

  .actions {
    button { font-size: ${fonts.default}px; }
    button:first-child {
      color: ${colors.black};
      opacity: 0.5;
    }
    button:last-child {
      color: ${colors.red04};
    }
  }
`;
